import { createI18n } from "vue-i18n";

// Import the language files directly from the locales folder
import alMessages from "./al/main.json";
import enMessages from "./en/main.json";
import srMessages from "./sr/main.json";

// Define the messages object
const messages = {
  AL: alMessages,
  ENG: enMessages,
  SRB: srMessages,
};

// Get the language from localStorage or default to "al"
const lang = localStorage.getItem("lang") || "AL";

const i18n = createI18n({
  legacy: true, // Use legacy mode for Vue 3 i18n if needed
  locale: lang,
  fallbackLocale: "AL",
  messages, // Pass the messages object
  globalInjection: true,
});

export default i18n;
